import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 40" {...this.props}><title>segment (small)</title><path className="st0" d="M1.9 0L0 1.9v6.3l4 3.7 4-3.7V0H1.9zm0 28L0 29.9v6.3l4 3.7 4-3.7V28H1.9zM3 15h2v10H3z" fill="currentColor" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/segment-small.inline.svg